export const groupIdMapper: Record<number, number> = {
  0: 2,
  5: 6,
  1: 2,
  3: 4,
};
